<template>
  <sui-segment class="home">
 <v-tabs
      v-if="isAdmin"
      v-model="tab"
      background-color="white"
      centered
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#user" @click.prevent='updateTab'>
        {{$t("users")}}
        <v-icon>mdi-account-group</v-icon>
      </v-tab>

      <v-tab v-if="isAdmin" href="#admins" @click.prevent='updateTab'>
        {{$t("admins")}}
        <v-icon>mdi-account-tie</v-icon>
      </v-tab>
    </v-tabs>

    <DataTable :key="updateTable"
              v-if="tab=='user'"
              uri="user"
              searchable
              long
              create
              :options="tableOptions"
              v-on:clickCreate="handleClickCreate"
              v-on:clickEdit="handleClickEdit"
              v-on:clickRow="callbackClickRow"
              v-on:clickRemove="callbackClickRemove" />
      
        <DataTable :key="updateTable"
              v-if="tab=='admins'"
              uri="admins"
              searchable
              long
              create
              :options="tableOptions"
              v-on:clickCreate="handleClickCreate"
              v-on:clickEdit="handleClickEdit"
              v-on:clickRow="callbackClickRow"
              v-on:clickRemove="callbackClickRemove" />

  	<sui-modal v-model="showModal">
      <sui-modal-header>{{$t(mode + tab)}}</sui-modal-header>
      <sui-modal-content  scrolling image>
        <sui-modal-description>
            <v-row>
              <v-col>
             <v-text-field 
             :label="$t('firstname')"
             v-model="current.firstname"></v-text-field></v-col>
              <v-col>
             <v-text-field 
             :label="$t('lastname')"
             v-model="current.lastname"></v-text-field></v-col>
            </v-row>
            <v-row>
              <v-col>
              <v-text-field
             :label="$t('email')"
             v-model="current.email"></v-text-field></v-col>
              <v-col>
              <v-text-field
             :label="$t('phone')"
             v-model="current.phone"></v-text-field></v-col>
            </v-row>
           <v-row>
              <v-col>
            <v-select
            :items="[{key:0,label:$t('enby')},{key:1,label:$t('female')},{key:2,label:$t('male')}]" 
            item-text="label"
            item-value="key"
            v-model="current.gender"
            :label="$t('gender')">
            </v-select></v-col>
              <v-col>
              <v-text-field
             :label="$t('company')"
             v-model="current.company"></v-text-field></v-col>
            </v-row> 
            <v-row>
              <v-col>
              <v-text-field
             :label="$t('password')"
              type="password"
              v-model="current.password"
              > </v-text-field></v-col>
              <v-col>
              <v-text-field
             :label="$t('confirmPassword')"
              type="password"
              v-model="current.confirmPassword"
              > </v-text-field></v-col>
            </v-row>
            <v-row v-if="tab == 'admins'">
              <v-select
                :items='[{key:"shopadmin",label:$t("shopadmin")},{key:"companyadmin",label:$t("companyadmin")}]'
                item-value="key"
                item-text="label"
                :label="$t('role')"
                v-model="current.role"></v-select>
            </v-row>
            <v-row>
              <v-select
                :items='groupDropdown'
                item-value="key"
                item-text="value"
                multiple
                :label="$t('groups')"
                v-model="current.groups"></v-select>
            </v-row>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click.native="handleSave">
          {{$t('save')}}
        </sui-button>
      </sui-modal-actions>
    </sui-modal>
  </sui-segment>
</template>

<script>

import DataTable from '@/components/DataTable.vue';
import ApiService from '@/services/ApiService.js';
// import PermissionService from '@/services/PermissionService.js';
export default {
  components: {
    DataTable
  },
  name: 'Home',
  data(){
    return {
        updateTable: 0,
        tableOptions: {
          columns: [
            // { label: this.$t('public'), name: 'is_public', width: 2, render: function (val, row) { return '<i class="ui ' + (val ? 'check' : 'times')+' icon"></i>' }},
            {label: this.$t('name'), name: 'firstname' },
            {label: this.$t("lastname"), name: "lastname"},
            {label: this.$t("role"), name: "role",translate:true},
            // {label: this.$t("landingpage"), name: "landingpage_id", landingpage: true}, //, render: function(val) { landingpages.find(page => page.id == val).name }
            {label: this.$t('createdAt'), name: 'created_at',time:true},
            {label: this.$t('actions'), name: 'actions', sortable: false },
          ],
          search: '',
          start: 0,
          limit: 10,
          sortKey: 'id',
          sortAs: "asc"
        },
        showModal: false,
        mode: "create",
        current: {},
        tab: "user",
        noClick:false,
        groupDropdown: [],
        isAdmin:false,
    }
  },
  async created(){
    localStorage.getItem("userTab") != null ? this.tab = localStorage.getItem("userTab") : ""
    // alert(this.tab)
    let role = this.$store.getters.role
    console.log(role)
    role.name == "shopadmin" ? this.isAdmin = true : this.tab = "user"
	  let res = await ApiService.getGroupDropdown();
        for(let [key, value] of Object.entries(res.data)){
			this.groupDropdown.push({key:key, value:value})
		}
  },
  methods: {
    handleClickCreate(){
      this.mode = "create"
      this.current = {}
      this.showModal = true
    },
    handleClickEdit(row){
      if(this.noClick == false && this.showModal == false)
        this.$router.push("/management/user/" + row.id + "?edit=true")
      // console.log("edit" + row.id)
      // this.noClick = true
      // this.mode = "edit"
      // this.current = row
      // this.current.role = this.current.role[0]
      // this.showModal = true
      // this.noClick = false
    },
    updateTab(){
      this.tab == "user" ? this.tab = "admins" : this.tab = "user"
      this.updateTable++
      localStorage.setItem("userTab", this.tab)
    },
    async handleSave(){
      if(this.mode == "create"){
        if(this.current.password == null || this.current.password.length < 6){
          this.$swal({
            icon: "error",
            title: this.$t("error"),
            text: this.$t("passwordAtLeast6Letters")
          })
          return
        }
        if(this.current.password != this.current.confirmPassword){
          this.$swal({
            icon: "error",
            title: this.$t("error"),
            text: this.$t("passwordsDontMatch")
          })
          return
        }

        let res;
        if(this.tab == "user"){
          res = await ApiService.postUser(this.current)
        }else{
          res = await ApiService.postAdmin(this.current)
          }
        if(res.status == 201){
          this.$swal({
            icon: "success",
            title: this.$t("success"),
            text: this.$t("created")
          })
          this.updateTable++
          this.showModal = false
        }
      }else{
        if(this.current.password != null && this.current.password != this.current.confirmPassword){
          this.$swal({
            icon: "error",
            title: this.$t("error"),
            text: this.$t("passwordsDontMatch")
          })
          return
        }
                let res = await ApiService.putUser(this.current.id,{
                  firstname: this.current.firstname,
                  lastname: this.current.lastname,
                  phone: this.current.phone,
                  email: this.current.email,
                  gender: this.current.gender,
                  password: this.current.password,
                  company: this.current.company,
                  groups: this.current.groups,
                  })
        if(res.status == 200){
          this.$swal({
            icon: "success",
            title: this.$t("success"),
            text: this.$t("created")
          })
          this.updateTable++
          this.showModal = false
        }
      }
    },
    callbackClickRow(row){
      if(this.noClick == false && this.showModal == false)
        this.$router.push("/management/user/" + row.id)
    },
	  async callbackClickRemove(row){
		this.$swal.fire({
			icon: "warning",
			title: this.$t("areYouSure"),
			text: this.$t("youCantRevert"),
			showCancelButton: false,
			showDenyButton: true,
			confirmButtonText: this.$t('yesDelete'),
			denyButtonText: this.$t("noKeep")
			}).then(async(result) => {
			if (result.isConfirmed) {
				let res = await ApiService.deleteUser(row.id);
				if (res===false) {
			  		this.updateTable++
					  this.$swal({
						  icon: "success",
						  title: this.$t("deleted"),
						  text: this.$t("deleteSuccess")
					  })
				}
			}
		})
	  }
  }
}
</script>
